<template>
  <v-main>

    <v-container
        id="notifications-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-account-multiple-outline"
          class="px-5 py-5"
      >

        <shared-page-messages :error-messages="errorMessages"
                              :warning-messages="warningMessages"
                              :success-messages="successMessages">
        </shared-page-messages>


        <v-card-text>
          <v-card-title class="pr-0">
            <v-row>

              <v-col
                  cols="12"
                  sm="12"
                  class="float-right p-0 mb-5"
              >

                <v-dialog
                    v-model="filtersDialog"
                    max-width="400"
                >

                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        class="float-right mr-0"
                    >
                      <v-icon size="small">mdi-filter</v-icon> Filters
                    </v-btn>
                  </template>


                  <form @submit.prevent="applyFilters">

                    <v-card>
                      <v-card-title class="text-h5">
                        Notification Filters
                      </v-card-title>

                      <v-card-text>
                        <v-row dense>
                          <v-col
                              cols="6"
                              sm="6"
                          >
                            <v-select
                                v-model="filter.statuses"
                                :items="computedNotificationStatusItems"
                                label="Status"
                                dense
                                multiple
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="6"
                              sm="6"
                          >
                            <v-select
                                v-model="filter.type"
                                :items="computedNotificationTypeItems"
                                label="Type"
                                dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col
                              cols="12"
                              sm="12"
                          >
                            <v-text-field
                                v-model="filter.firstName"
                                label="First Name"
                                dense
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col
                              cols="12"
                              sm="12"
                          >
                            <v-text-field
                                v-model="filter.lastName"
                                label="Last Name"
                                dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col
                              cols="12"
                              sm="12"
                          >
                            <v-text-field
                                v-model="filter.emailAddress"
                                label="Email Address"
                                dense
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col
                              cols="12"
                              sm="12"
                          >
                            <v-text-field
                                v-model="filter.phoneNumber"
                                label="Phone Number"
                                dense
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col
                              cols="4"
                              sm="4"
                          >
                            <v-select
                                v-model="filter.itemsPerPage"
                                :items="[25, 50, 100, 200, 500]"
                                label="Items Per Page"
                                dense
                            >

                            </v-select>
                          </v-col>
                        </v-row>

                      </v-card-text>

                      <v-card-actions class="pt-0">
                        <v-spacer></v-spacer>
                          <v-btn
                              small
                              color="primary"
                              @click="filtersDialog = false"
                              class="mx-1"
                          >
                            Close
                          </v-btn>
                          <v-btn
                              small
                              color="primary"
                              type="submit"
                              class="mx-1"
                          >
                            Apply
                          </v-btn>
                          <v-btn
                              small
                              color="primary"
                              class="mx-1"
                              @click="resetFilters"
                          >
                            Reset
                          </v-btn>
                      </v-card-actions>

                    </v-card>

                  </form>

                </v-dialog>
              </v-col>
            </v-row>
          </v-card-title>

          <v-data-table
              :headers="headers"
              :items="notifications"
              :items-per-page="filter.itemsPerPage"
              class="elevation-1"
              loading-text="Loading... Please wait"
              dense
              hide-default-header
              hide-default-footer
          >
            <template v-slot:header="{ props, on }">
              <thead class="custom-header-style">
              <tr>
                <th v-for="header in props.headers" :key="header.value" v-on="on">
                  <span class="text-subtitle-2">{{ header.text }}</span>
                </th>
              </tr>
              </thead>
            </template>

            <template v-slot:item.type="{ item: notification }">
              {{ notificationTypeMap[notification.type] || notification.type }}
            </template>

            <template v-slot:item.status="{ item: notification }">
              <span v-if="notification.status === 'FAILED'" class="error--text">
                {{ notificationStatusMap[notification.status] }}
              </span>
              <span v-else-if="notification.status === 'SENT'" class="success--text">
                {{ notificationStatusMap[notification.status] }}
              </span>
              <span v-else>
                {{ notificationStatusMap[notification.status] || notification.status }}
              </span>
            </template>

            <template v-slot:item.sentAt="{ item: notification }">
              <span v-if="notification.sentAt">{{ notification.sentAt | formatDateTime }}</span>
              <span v-else>-</span>
            </template>
          </v-data-table>

          <div class="text-center mt-3">
            <v-pagination
                :length="searchResponse.page.totalPages || 1"
                :value="filter.page"
                @input="fetchNotifications"
            ></v-pagination>
          </div>

        </v-card-text>


      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import constants from '@/utils/constants'
import SharedPageMessages from '../shared/PageMessages.vue'

export default {
  name: 'CoreNotificationsView',

  components: {
    SharedPageMessages
  },

  async created() {
    await this.fetchNotifications()
  },

  props: [
      'notificationStatuses'
  ],

  computed: {
    notifications: {
      get: function () {
        return this.searchResponse.content || []
      }
    },
    computedNotificationTypeItems: {
      get: function () {
        return Object.keys(this.notificationTypeMap)
            .map((key) => ({value: key, text: this.notificationTypeMap[key]}))
      }
    },
    computedNotificationStatusItems: {
      get: function () {
        return Object.keys(this.notificationStatusMap)
            .map((key) => ({value: key, text: this.notificationStatusMap[key]}))
      }
    }
  },

  watch: {
    searchResponse() {
      this.clearMessages()
      if (this.searchResponse.page.totalElements === 0) {
        this.warningMessages.push("Sorry, no notifications matching your filter criteria could be found. Please adjust your filters.")
      }
    },
    errorMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    successMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    },
    warningMessages: function (val) {
      if (val.length > 0) {
        scroll(0, 0)
      }
    }
  },

  methods: {
    clearMessages() {
      this.successMessages = []
      this.errorMessages = []
      this.warningMessages = []
    },
    applyFilters() {
      this.filtersDialog = false
      this.clearMessages()
      this.fetchNotifications()
    },
    resetFilters() {
      this.filtersDialog = false
      this.clearMessages()
      this.filter = {
        type: null,
        to: '',
        statuses: [],
        firstName: '',
        lastName: '',
        emailAddress: '',
        phoneNumber: '',
        itemsPerPage: 25,
        page: 1,
      }
      this.fetchNotifications()
    },
    async fetchNotifications(page) {
      this.clearMessages()
      this.filter.page = page || 1
      let params = {
        page: this.filter.page,
        type: this.filter.type,
        statuses: this.filter.statuses.join(','),
        firstName: this.filter.firstName,
        lastName: this.filter.lastName,
        emailAddress: this.filter.emailAddress,
        phoneNumber: this.filter.phoneNumber,
        limit: this.filter.itemsPerPage,
      }
      await api.fetchNotifications(params)
          .then(response => {
            this.searchResponse = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err, true)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Member',
          value: 'toUser.names'
        },
        {
          text: 'To Email/Phone',
          value: 'to'
        },
        {
          text: 'Subject',
          value: 'subject'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Attempts',
          value: 'attempts'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Sent At',
          value: 'sentAt'
        }
      ],
      searchResponse: {
        content: [],
        empty: true,
        page: {
          size: 0,
          number: 0,
          totalPages: 0,
          totalElements: 0
        }
      },
      filter: {
        statuses: [],
        page: 1,
        type: null,
        firstName: '',
        lastName: '',
        emailAddress: '',
        phoneNumber: '',
        itemsPerPage: 25,
      },
      filtersDialog: false,
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      notificationStatusMap: constants.getNotificationStatusMap(),
      notificationTypeMap: {
        EMAIL: 'Email',
        SMS: 'SMS'
      }
    }
  }
}
</script>


<style lang="sass">
  th.notification-member, th.notification-to, th.notification-subject, th.notification-type
    width: 10%

  th.notification-sent-at
    width: 6%

  th.notification-status, th.notification-type
    width: 2%

  th.notification-attempts
    width: 1%

  th.notification-action
    width: 5%

</style>
